module.exports = __webpack_public_path__ + "img/empty_paciente.0181883a.png";